<template>
    <div class="form">
        <a-card :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                :wrapper-col="wrapperCol">
                <p class="form_sub_title">基础信息</p>
                <a-form-model-item ref="usercode" v-show="record.usercode" label="用户编码" prop="usercode">
                    <span class="form_span">{{record.usercode}}</span>
                </a-form-model-item>
                <a-form-model-item ref="fullname" label="用户姓名" prop="fullname">
                    <a-input v-if="is_vue_task" v-model="record.fullname" :disabled="disabled" />
                    <span v-else class="form_span">{{record.fullname}}</span>

                </a-form-model-item>

                <a-form-model-item label="用户手机号" prop="tel">
                    <a-input v-if="is_vue_task" v-model="record.tel" :disabled="disabled" />
                    <span v-else class="form_span">{{record.tel}}</span>
                </a-form-model-item>

                <a-form-model-item label="用户邮箱" prop="email">
                    <a-input v-if="is_vue_task" v-model="record.email" :disabled="disabled" />
                    <span v-else class="form_span">{{record.email}}</span>
                </a-form-model-item>

                <p class="form_sub_title">工作信息</p>

                <a-form-model-item label="用户密码" prop="password" v-if="is_vue_new">
                    <a-input v-if="is_vue_task" v-model="record.password" :disabled="disabled" />
                    <span v-else class="form_span">{{record.password}}</span>
                </a-form-model-item>


                <a-form-model-item label="所属组织">
                    <!-- 所属组织 -->
                    <a-button type="primary" @click="handleOrgSelect" v-if="is_vue_task">
                        所属组织
                    </a-button>

                    <!-- 组织列表 -->
                    <a-table :columns="columns_org" :data-source="record.organization" :pagination="false"
                        :loading="tLoading" rowKey="organizationcode">
                        <template slot="operation" slot-scope="text, record">
                            <div class="editable-row-operations">
                                <span>
                                    <router-link v-if="is_vue_task" :to="{
                        path:'orgdetail',
                        query: {
                            organizationcode: record.organizationcode
                        }
                    }">查看</router-link>
                                </span>
                                <span style="margin-left:15px;">
                                    <a-popconfirm @confirm="() => onOrgDelete(record)" v-if="is_vue_task">
                                        <template slot="title">
                                            <p>{{ '确认将【' + record.organizationname+ '】删除？' }}</p>
                                        </template>
                                        <a>删除</a>
                                    </a-popconfirm>
                                </span>
                            </div>
                        </template>
                    </a-table>

                </a-form-model-item>

                <a-form-model-item label="所属角色">
                    <!-- 所属角色 -->
                    <a-button type="primary" @click="handleRoleSelect" v-if="is_vue_task">
                        所属角色
                    </a-button>

                    <!-- 角色列表 -->
                    <a-table :columns="columns_role" :data-source="record.role" :pagination="false" :loading="tLoading"
                        rowKey="code">
                        <template slot="operation" slot-scope="text, record">
                            <div class="editable-row-operations">
                                <span style="margin-left:15px;">
                                    <a-popconfirm @confirm="() => onRoleDelete(record)" v-if="is_vue_task">
                                        <template slot="title">
                                            <p>{{ '确认将【' + record.name+ '】删除？' }}</p>
                                        </template>
                                        <a>删除</a>
                                    </a-popconfirm>
                                </span>
                            </div>
                        </template>
                    </a-table>

                </a-form-model-item>

                <a-form-model-item label="所属系统">
                    <!-- 所属系统 -->
                    <a-button type="primary" @click="handleSystemSelect" v-if="is_vue_task">
                        所属系统
                    </a-button>

                    <!-- 系统列表 -->
                    <a-table :columns="columns_system" :data-source="record.system" :pagination="false"
                        :loading="tLoading" rowKey="syscode">
                        <template slot="operation" slot-scope="text, record">
                            <div class="editable-row-operations">
                                <span style="margin-left:15px;">
                                    <a-popconfirm @confirm="() => onSystemDelete(record)" v-if="is_vue_task">
                                        <template slot="title">
                                            <p>{{ '确认将【' + record.sysname+ '】删除？' }}</p>
                                        </template>
                                        <a>删除</a>
                                    </a-popconfirm>
                                </span>
                            </div>
                        </template>
                    </a-table>
                </a-form-model-item>

                <a-form-model-item label="岗位" prop="postname">
                    <a-input v-if="is_vue_task" v-model="record.postname" :disabled="disabled" />
                    <span v-else class="form_span">{{record.postname}}</span>
                </a-form-model-item>
                <a-form-model-item ref="usertype" label="用户类型" prop="usertype">
                    <a-radio-group v-model="record.usertype" button-style="solid" style="margin-left:15px"
                        v-if="is_vue_task">
                        <a-radio-button value="1">
                            试用
                        </a-radio-button>
                        <a-radio-button value="2">
                            正式
                        </a-radio-button>
                        <a-radio-button value="3">
                            离职
                        </a-radio-button>
                    </a-radio-group>
                    <span v-else class="form_span">{{['','试用','正式','离职'][parseInt(record.usertype)]}}</span>
                </a-form-model-item>

                <a-form-model-item label="入职时间" prop="entrytime">
                    <a-date-picker v-model="record.entrytime" format="YYYY-MM-DD" v-if="is_vue_task" />
                    <span v-else>{{record.entrytime}}</span>
                </a-form-model-item>
                <a-form-model-item label="转正时间" prop="positivetime">
                    <a-date-picker v-model="record.positivetime" type="date" format="YYYY-MM-DD" v-if="is_vue_task" />
                    <span v-else>{{record.positivetime}}</span>
                </a-form-model-item>

                <a-form-model-item label="离职时间" prop="quittime">
                    <a-date-picker v-model="record.quittime" format="YYYY-MM-DD" v-if="is_vue_task" />
                    <span v-else>{{record.quittime}}</span>
                </a-form-model-item>

                <a-form-model-item :wrapper-col="{ span: 14, offset: 14 }" v-show="is_vue_task">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

            <SelecterModel ref="tableselectM" @onModalHide="handleModalHide"></SelecterModel>


        </a-card>
    </div>

</template>
<script>
import { mapState } from "vuex";
import SelecterModel from './selecter'

const m_title = {
    'adduser':'新增用户',
    'detailuser':'查看用户',
    'edituser':'编辑用户',
};

const columns_org = [
    {
        title: '组织编码',
        dataIndex: 'organizationcode',
        align: 'center',
        width:150
    },
    {
        title: '组织名称',
        dataIndex: 'organizationname',
        align: 'center',
        width:150
    },
    {
        title: '上级组织',
        dataIndex: 'uporganizationname',
        align: 'center',
        width:150
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    }
];

const columns_role = [
    {
        title: '角色编码',
        dataIndex: 'code',
        align: 'center',
        width:150
    },
    {
        title: '角色名称',
        dataIndex: 'name',
        align: 'center',
        width:150
    },
    {
        title: '有效性',
        dataIndex: 'iseffective',
        align: 'center',
        width:150
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    }
]

const columns_system = [
    {
        title: '系统编码',
        dataIndex: 'syscode',
        align: 'center',
        width:150
    },
    {
        title: '系统名称',
        dataIndex: 'sysname',
        align: 'center',
        width:150
    },
    {
        title: '',
        dataIndex: '',
        align: 'center',
        width:150
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    }
]

export default {
    data() {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                fullname: [
                    { required: true, message: '请输入用户名称', trigger: 'blur' },
                ],
                tel:[
                    { required: true, message: '请输入用户手机号', trigger: 'blur' },
                ],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                ],
                usertype:[
                    { required: true, message: '请选择用户类型', trigger: 'blur' },
                ],
                password:[
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
            },
            columns_org:columns_org,
            columns_role:columns_role,
            columns_system:columns_system,
            confirmLoading: false,
            formItemLayout:'horizontal',
            c_title:'',
            is_vue_task : true,
            is_vue_new: false,
            tLoading:false,
            disabled: this.$route.params.action == "detailuser" ? true : false,
        };
    },

    methods: {
        onOrgDelete(item){
            this.record.organization = this.record.organization.filter(({id}) => id != item.id)
        },
        onRoleDelete(item){
            this.record.role = this.record.role.filter(({id}) => id != item.id)
        },
        onSystemDelete(item){
            this.record.system = this.record.system.filter(({id}) => id != item.id)
        },
        handleOrgSelect(){
            const { query} = this.$route;
            this.$refs.tableselectM.onModalInit(query.usercode,1,1,this.record.organization);
        },
        handleRoleSelect(){
            this.$refs.tableselectM.onModalInitRole(1,1,this.record.role);
        },
        handleSystemSelect(){
            this.$refs.tableselectM.onModalInitAuthSystem(1,1,this.record.system);
        },

        //选择所属组织确认
        handleModalHide(c_list,c_type){
            if(!c_list){
                return
            }
            if(c_type == 1){
                this.record.organization = c_list
            }
            else if(c_type==2){
                this.record.role =  c_list
            }
            else if(c_type==3){
                this.record.system =  c_list
            }
        },
        //选择所属角色确认
        handleOk() {
            let c_record = JSON.stringify(this.record);
            c_record = JSON.parse(c_record)
            if(c_record.organization.length == 0){
                this.message.warning('请选择所属组织！');
                return;
            }
            if(c_record.role.length == 0){
                this.message.warning('请选择所属角色！');
                return;
            }
            c_record.organization = JSON.stringify(c_record.organization)
            c_record.role = JSON.stringify(c_record.role)
            c_record.system = JSON.stringify(c_record.system)

            c_record.positivetime = c_record.positivetime ?  this.dateFormat('YYYY-mm-dd',new Date(c_record.positivetime)) : '';
            c_record.entrytime =c_record.entrytime ? this.dateFormat('YYYY-mm-dd',new Date(c_record.entrytime)): '';
            c_record.quittime =c_record.quittime ? this.dateFormat('YYYY-mm-dd',new Date(c_record.quittime)): '';


            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    const { params } = this.$route;
                    if(params.action == 'edituser'){
                        //编辑
                        this.$store
                            .dispatch({
                                type: "usercenter/updateAddUser",
                                params: c_record
                            })
                            .then((response) => {
                                console.log(response)
                                this.handleCancel();
                                this.confirmLoading = false;
                            });
                    }
                    else if(params.action == 'adduser'){
                        //新增
                        this.$store
                            .dispatch({
                                type: "usercenter/updateAddUser",
                                params: c_record
                            })
                            .then((response) => {
                                console.log(response)
                                if(response.data.success == '1'){
                                    this.handleCancel();
                                }
                                else{
                                    // this.$refs.ruleForm.resetFields();
                                    this.confirmLoading = false;

                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            
        },
        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
    computed: {
        ...mapState("usercenter", {
            record: function(state) {
                return this.action == "adduser" ? {} : state.record;
            }
        })
    },
    components:{
        SelecterModel
    },
    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action]
        if (params.action != "adduser") {
            this.$store.dispatch({
                type: "usercenter/detailUser",
                params: query,
                showMsg: false
            })
        }
        else{
            this.$store.dispatch({
                type: "usercenter/getEmptyUser",
                params: query,
                showMsg: false
            })  
        }
        this.is_vue_task = params.action != 'detailuser'
        this.is_vue_new = params.action == 'adduser' || params.action == 'edituser'
        if(params.action == 'adduser'){
            this.rules.password[0].required = true;
        }
        if(params.action == 'edituser'){
            this.rules.password[0].required = false;
        }
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
.ant-input[disabled]{
    color: rgba(0, 0, 0, 0.55);
}
.form_span{
    font-size: 14px;
    font-weight: bolder;
}
.form_sub_title{
    font-weight: bold;
}
</style>
